var _rect, _rect2, _g, _rect3, _rect4, _g2, _rect5, _rect6, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuestsEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 90,
    viewBox: "0 0 204 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 136,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 18,
    y: 10,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#4494FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9983 14.8572C26.0534 14.8572 22.8555 18.0551 22.8555 22C22.8555 25.9449 26.0534 29.1429 29.9983 29.1429C33.9432 29.1429 37.1412 25.9449 37.1412 22C37.1412 20.1056 36.3886 18.2888 35.0491 16.9493C33.7095 15.6097 31.8927 14.8572 29.9983 14.8572ZM29.9983 17C31.1818 17 32.1412 17.9594 32.1412 19.1429C32.1412 20.3264 31.1818 21.2857 29.9983 21.2857C28.8149 21.2857 27.8555 20.3264 27.8555 19.1429C27.8555 17.9594 28.8149 17 29.9983 17ZM34.0126 24.9715C33.0694 26.2417 31.5805 26.9906 29.9983 26.9906C28.4161 26.9906 26.9273 26.2417 25.984 24.9715C25.8406 24.7595 25.8215 24.487 25.934 24.2572L26.084 23.9429C26.4375 23.1936 27.1913 22.7152 28.0198 22.7143H31.9769C32.7937 22.7154 33.5389 23.1808 33.8983 23.9143L34.0626 24.25C34.1779 24.4818 34.1588 24.7578 34.0126 24.9715Z",
    fill: "#4494FF"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 50,
    width: 136,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 50,
    y: 58,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#4494FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9983 62.8572C58.0534 62.8572 54.8555 66.0551 54.8555 70C54.8555 73.9449 58.0534 77.1429 61.9983 77.1429C65.9432 77.1429 69.1412 73.9449 69.1412 70C69.1412 68.1056 68.3886 66.2888 67.0491 64.9493C65.7095 63.6097 63.8927 62.8572 61.9983 62.8572ZM61.9983 65C63.1818 65 64.1412 65.9594 64.1412 67.1429C64.1412 68.3264 63.1818 69.2857 61.9983 69.2857C60.8149 69.2857 59.8555 68.3264 59.8555 67.1429C59.8555 65.9594 60.8149 65 61.9983 65ZM66.0126 72.9715C65.0694 74.2417 63.5805 74.9906 61.9983 74.9906C60.4161 74.9906 58.9273 74.2417 57.984 72.9715C57.8406 72.7595 57.8215 72.487 57.934 72.2572L58.084 71.9429C58.4375 71.1936 59.1913 70.7152 60.0198 70.7143H63.9769C64.7937 70.7154 65.5389 71.1808 65.8983 71.9143L66.0626 72.25C66.1779 72.4818 66.1588 72.7578 66.0126 72.9715Z",
    fill: "#4494FF"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 18,
    width: 80,
    height: 8,
    rx: 2,
    fill: "#C2CFE0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 66,
    width: 80,
    height: 8,
    rx: 2,
    fill: "#C2CFE0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 50,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8327 65.5833V66.4166C23.8327 66.6467 23.6461 66.8333 23.416 66.8333H18.8327V71.4166C18.8327 71.6467 18.6461 71.8333 18.416 71.8333H17.5827C17.3526 71.8333 17.166 71.6467 17.166 71.4166V66.8333H12.5827C12.3526 66.8333 12.166 66.6467 12.166 66.4166V65.5833C12.166 65.3532 12.3526 65.1666 12.5827 65.1666H17.166V60.5833C17.166 60.3532 17.3526 60.1666 17.5827 60.1666H18.416C18.6461 60.1666 18.8327 60.3532 18.8327 60.5833V65.1666H23.416C23.6461 65.1666 23.8327 65.3532 23.8327 65.5833Z",
    fill: "#4494FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 2,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.375 13.6875V14.3125C178.375 14.4851 178.235 14.625 178.062 14.625H174.625V18.0625C174.625 18.2351 174.485 18.375 174.312 18.375H173.688C173.515 18.375 173.375 18.2351 173.375 18.0625V14.625H169.938C169.765 14.625 169.625 14.4851 169.625 14.3125V13.6875C169.625 13.5149 169.765 13.375 169.938 13.375H173.375V9.9375C173.375 9.76491 173.515 9.625 173.688 9.625H174.312C174.485 9.625 174.625 9.76491 174.625 9.9375V13.375H178.062C178.235 13.375 178.375 13.5149 178.375 13.6875Z",
    fill: "#4494FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 50,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.917 57.7917V58.2084C196.917 58.3234 196.824 58.4167 196.709 58.4167H194.417V60.7084C194.417 60.8234 194.324 60.9167 194.209 60.9167H193.792C193.677 60.9167 193.584 60.8234 193.584 60.7084V58.4167H191.292C191.177 58.4167 191.084 58.3234 191.084 58.2084V57.7917C191.084 57.6766 191.177 57.5834 191.292 57.5834H193.584V55.2917C193.584 55.1766 193.677 55.0834 193.792 55.0834H194.209C194.324 55.0834 194.417 55.1766 194.417 55.2917V57.5834H196.709C196.824 57.5834 196.917 57.6766 196.917 57.7917Z",
    fill: "#4494FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0,
    y: 48,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 160,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 184,
    y: 48,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(21.4277 13.4286)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(53.4277 61.4286)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestsEmpty);
export default __webpack_public_path__ + "static/media/guests-empty.80db2e8c.svg";
export { ForwardRef as ReactComponent };